export default __webpack_public_path__ + "static/media/os_aran_w_500ffc-webfont.9baf5eee.woff2";